import jupyterLogo from '../assets/jupyter-Logo.png';
import vscodeLogo from '../assets/vscode-Logo.jpeg';
import mongoLogo from '../assets/mongo.svg';
import elasticLogo from '../assets/elasticsearch.svg';
import airflowLogo from '../assets/airflowLogo.png';
import fluxLogo from '../assets/flux-stack-110x117.png';
import grafanaLogo from '../assets/grafana-logoo-removebg.png';
import grafanaLokiLogo from '../assets/GrafanaLoki-Logo.png';
import jenkinsLogo from '../assets/Jenkins-Logo.png';
import mariadbLogo from '../assets/mariadb-logo.png';
import postgresqlLogo from '../assets/Postgresql_elephant.svg.png';
import qdrantLogo from '../assets/qdrant.png';
import n8nLogo from '../assets/n8n.jpg';
import crewAILogo from '../assets/crewai.jpeg';
import redisLogo from '../assets/redis.svg';
import rabbitmqLogo from '../assets/rabbitmq-logo-png-transparent.png';
import openwebuiLogo from '../assets/openwebuilogo.png';
import OllamaLogo from '../assets/ollamaLogo.png';
import agLogo from '../assets/agLogo.svg';
import codePyLogo from '../assets/python-Logo.jpg';
import nodeCodeLogo from '../assets/nodejs-Logo.png';
import Neo4jLogo from '../assets/neo4j.png';
import StreamlitLogo from '../assets/streamlit.png';
import langflowLogo from '../assets/langg.jpg';



export const subtitles = [
    'Launch software instantly.',
    'Explore tools in seconds.',
    'Learn and experiment freely.',
    'All tools, one click.',
    'Build and deploy fast.',
    'Try and test easily.',
    'Code to cloud instantly.',
    'Innovate without limits.',
    'No setup, just launch.',
    'Your cloud playground.'
];

export const headings = [
    'Your Cloud Software Hub',
    'Explore Cloud Tools Instantly',
    'Cloud Lab: Launch & Learn',
    'All-in-One Cloud Playground',
    'Instant Software, Infinite Possibilities',
    'Cloud Apps at Your Fingertips',
    'One Click to the Cloud',
    'Experiment with Cloud Software',
    'Your Gateway to Cloud Innovation',
    'Discover, Launch, Innovate'
];

export const DocumentList = {
    // Free/Open Source Software
    'vscode': {
        name: 'VS Code',
        logo: vscodeLogo,
        description:
            'Code, debug, and develop in multiple languages with extensions.',
        docsLink: 'https://code.visualstudio.com/docs',
        hasUI: true,
    },
    'jupyter-notebook': {
        name: 'Jupyter Notebook',
        logo: jupyterLogo,
        description:
            'Create and share documents with live code and visualizations.',
        docsLink: 'https://jupyter-notebook.readthedocs.io/en/stable/',
        hasUI: true,
    },
    'playground-jupyter': {
        name: 'Jupyter Hub with MongoDB',
        logo: jupyterLogo,
        description:
            'Collaborative coding and data analysis environment.',
        docsLink: 'https://jupyterhub.readthedocs.io/en/stable/',
        hasUI: true,
    },
    'elasticsearch': {
        name: 'Elastic Search',
        logo: elasticLogo,
        description:
            'Real-time search and analytics engine for large datasets.',
        docsLink: 'https://www.elastic.co/guide/en/elasticsearch/reference/current/index.html',
        hasUI: false,
    },
    'airflow': {
        name: 'Airflow',
        logo: airflowLogo,
        description:
            'Programmatically author, schedule, and monitor workflows.',
        docsLink: 'https://airflow.apache.org/docs/',
        hasUI: true,
    },
    'flux': {
        name: 'Flux',
        logo: fluxLogo,
        description:
            'Continuous and progressive delivery tool.',
        docsLink: 'https://fluxcd.io/docs/',
        hasUI: false,
    },
    'grafana': {
        name: 'Grafana',
        logo: grafanaLogo,
        description:
            'Visualize metrics and logs for analytics and monitoring.',
        docsLink: 'https://grafana.com/docs/',
        hasUI: true,
    },
    'grafana-loki': {
        name: 'Grafana Loki',
        logo: grafanaLokiLogo,
        description:
            'Scalable log aggregation and search system.',
        docsLink: 'https://grafana.com/docs/loki/latest/',
        hasUI: false,
    },
    'jenkins': {
        name: 'Jenkins',
        logo: jenkinsLogo,
        description:
            'Open-source automation server for CI/CD workflows.',
        docsLink: 'https://www.jenkins.io/doc/',
        hasUI: true,
    },
    'mariadb': {
        name: 'MariaDB',
        logo: mariadbLogo,
        description:
            'Robust open-source relational database system.',
        docsLink: 'https://mariadb.com/kb/en/documentation/',
        hasUI: false,
    },
    'mongodb': {
        name: 'MongoDB',
        logo: mongoLogo,
        description:
            'Flexible NoSQL database for high performance.',
        docsLink: 'https://www.mongodb.com/docs/',
        hasUI: false,
    },
    'postgresql': {
        name: 'PostgreSQL',
        logo: postgresqlLogo,
        description:
            'Powerful open-source object-relational database.',
        docsLink: 'https://www.postgresql.org/docs/',
        hasUI: false,
    },
    'rabbitmq': {
        name: 'RabbitMQ',
        logo: rabbitmqLogo,
        description:
            'High-performance message broker for async communication.',
        docsLink: 'https://www.rabbitmq.com/documentation.html',
        hasUI: false,
    },
    'redis': {
        name: 'Redis',
        logo: redisLogo,
        description:
            'In-memory key-value store for caching and analytics.',
        docsLink: 'https://redis.io/docs/',
        hasUI: false,
    },
    'vscode-python': {
        name: 'VS Code Python',
        logo: codePyLogo,
        description:
            'VS Code with Python extensions for AI and data science.',
        docsLink: 'https://code.visualstudio.com/docs/languages/python',
        hasUI: true,
    },
    'vscode-nodejs': {
        name: 'VS Code Node',
        logo: nodeCodeLogo,
        description:
            'VS Code with Node.js extensions for JS development.',
        docsLink: 'https://code.visualstudio.com/docs/nodejs/working-with-javascript',
        hasUI: true,
    },
    'ollama': {
        name: 'Ollama',
        logo: OllamaLogo,
        description:
            'Lightweight framework for managing AI models.',
        docsLink: 'https://ollama.com/docs',
        hasUI: false,
    },
    'openwebui': {
        name: 'OpenWeb UI',
        logo: openwebuiLogo,
        description:
            'Intuitive interface for AI and automation tools.',
        docsLink: 'https://docs.openwebui.com/',
        hasUI: true,
    },
    'streamlit': {
        name: 'streamlit',
        logo: StreamlitLogo,
        description:
            'Quickly build interactive data apps in Python.',
        docsLink: 'https://docs.streamlit.io/',
        hasUI: true,
    },
    'n8n': {
        name: 'n8n',
        logo: n8nLogo,
        description:
            'Connect apps and automate workflows with integrations.',
        docsLink: 'https://docs.n8n.io/',
        hasUI: true,
    },
    'langflow': {
        name: 'LangFlow',
        logo: langflowLogo,
        description:
            'Build and deploy AI agents easily.',
        docsLink: 'https://docs.langflow.org/',
        hasUI: true,
    },

    // Paid/Commercial Software
    'crewai': {
        name: 'CrewAI',
        logo: crewAILogo,
        description:
            'Collaborative platform for building and managing AI solutions.',
        docsLink: 'https://docs.crewai.com/',
        hasUI: true,
    },
    'autogen-studio': {
        name: 'Autogen Studio',
        logo: agLogo,
        description:
            'Automate workflows and integrate AI-powered tools.',
        docsLink: 'https://microsoft.github.io/autogen/stable//index.html',
        hasUI: true,
    },
    'qdrant': {
        name: 'qdrant',
        logo: qdrantLogo,
        description:
            'Vector search engine for high-dimensional embeddings.',
        docsLink: 'https://qdrant.tech/documentation/',
        hasUI: false,
    },
    'neo4j': {
        name: 'neo4j',
        logo: Neo4jLogo,
        description:
            'Graph database for connected data and complex queries.',
        docsLink: 'https://neo4j.com/docs/',
        hasUI: false,
    },
};
